import { IUserGameInfo } from '@/interfaces/api/gamefi';
import {
  IGetPlayerPoolProfile,
  TokenDetail,
} from '@/interfaces/api/player-share';
import React from 'react';

export interface IProfilesContext {
  isProfileLoading: boolean;
  setIsProfileLoading: React.Dispatch<React.SetStateAction<boolean>>;

  yourPoolProfile: IGetPlayerPoolProfile | null;
  playerPoolProfile: IGetPlayerPoolProfile | null;
  setPlayerPoolProfile: React.Dispatch<
    React.SetStateAction<IGetPlayerPoolProfile | null>
  >;

  showCreatePost: boolean;
  setShowCreatePost: React.Dispatch<React.SetStateAction<boolean>>;

  userGameInfo: IUserGameInfo | undefined;
  setUserGameInfo: React.Dispatch<
    React.SetStateAction<IUserGameInfo | undefined>
  >;

  playerTokenDetail: TokenDetail | null;

  isTokenHolding: boolean;
  isTokenHolded: boolean;
  isTokenHoldingLoading: boolean;
  keyBalance: number;
  keyRemaining: number;
  balanceTokenHolded: number;
  balanceTokenHolding: number;
  balancePassTokenHolding: number;
  balancePassTokenHolded: number;
  holderLists: any[];
  fetchData: () => void;
  isSticky: boolean;
  setIsSticky: (b: boolean) => void;
  setTabActive: (b: number) => void;
  tabActive: number;
  userChatRoom: {
    dm: string;
    circle: string;
    community: string;
  };
}

export default React.createContext<IProfilesContext>({} as IProfilesContext);
